export default {
  // Page-level
  'customize.title': '定制与报价',
  'customize.backToProduct': '返回产品',
  'customize.backToProductList': '返回产品列表',
  'customize.loadingProduct': '正在加载产品信息...',
  'customize.productNotFound': '未找到产品',
  'customize.selectTargetHint': '请从左上角<br />选择定制目标<br />开始。',
  'customize.sku': 'SKU',
  'customize.category': '分类',
  'customize.capacity': '容量',
  'customize.material': '材质',
  'customize.weight': '重量',
  'customize.processCount': '{{count}} 个工序',
  'customize.orderQuantity': '订购数量',
  'customize.sampleQuantity': '样品数量',
  'customize.samplePurchase': '样品购买',
  'customize.unit': '件',
  'customize.addProcessTitle': '添加后加工工序',
  'customize.addProcessDesc': '在左侧树形菜单中点击所需的定制选项，即可在此处添加工序。',
  'customize.processStep': '工序 {{index}}',
  'customize.finalStep': '最后一步',
  'customize.cancel': '取消',
  'customize.printQuote': '输出报价单',
  'customize.previewTitle': '报价预览',
  'customize.calculating': '正在计算报价金额...',
  'customize.currency': '货币',
  'customize.appliedFx': '应用汇率',
  'customize.quantityLabel': '数量：{{count}} 件',
  'customize.itemTotal': '项目合计',
  'customize.productSubtotalUsd': '产品小计 (USD)',
  'customize.finishingSubtotalUsd': '后加工小计 (USD)',
  'customize.totalQuoteAmount': '报价总金额',
  'customize.close': '关闭',
  'customize.processing': '处理中...',
  'customize.requestQuote': '请求报价',

  // Errors
  'customize.error.loadingProduct': '正在加载产品信息。',
  'customize.error.loadingFinishing': '加载后加工报价信息失败，请稍后重试。',
  'customize.error.finishingMapping': '无法确认所选后加工的报价信息，请稍后重试。',
  'customize.error.preview': '请求报价预览时发生错误。',
  'customize.error.create': '生成报价时发生错误。',

  // Tree
  'customize.tree.title': '定制选项',
  'customize.tree.loginRequired': '登录后可使用后加工选项',
  'customize.tree.partsReplace': '更换配件 (CAP & PUMP)',
  'customize.tree.finishingColor': '后加工及颜色变更',
  'customize.tree.printingAdd': '添加后加工印刷',

  // Shared finishing selection labels
  'customize.selectPart': '选择部位',
  'customize.selectMethod': '后加工方式',
  'customize.selectColor': '选择颜色',
  'customize.selected': '已选择',
  'customize.methodsCount': '{{count}} 种方式',
  'customize.selectPartFirst': '- 请先选择部位',
  'customize.selectPartHint': '在左侧选择部位后，<br />将显示可用的后加工方式。',
  'customize.selectMethodFirst': '- 请先选择方式',
  'customize.confirmHint': '- 请按确认按钮',
  'customize.selectMethodHint': '在中间选择后加工方式后，<br />即可指定颜色。',
  'customize.popularColors': '热门颜色',
  'customize.premium': 'Premium',
  'customize.customInput': '自定义',
  'customize.changeColor': '更改颜色',
  'customize.changeColorHint': '您可以更改颜色或选择其他后加工方式。',
  'customize.reselect': '重新选择',
  'customize.confirm': '确认',
  'customize.resetAll': '全部重置',
  'customize.pantoneCode': 'Pantone 色号',
  'customize.noPantone': '未指定 Pantone',
  'customize.selectThisColor': '选择此颜色',
  'customize.selectColorButton': '选择此颜色',
  'customize.done': '完成',
  'customize.edit': '编辑',
  'customize.removeProcess': '移除此工序',
  'customize.confirmedMessage': '已按以下内容完成选择。',
  'customize.selectedConditions': '已选条件 ({{count}} 项)：',
  'customize.metallic': '金属色',
  'customize.pearl': '珠光',
  'customize.softTouch': '柔软触感',
  'customize.pantoneRequired': '请输入 Pantone 色号。',
  'customize.hexInvalid': '请输入有效的 HEX 颜色代码。(例如：#FF6B6B)',
  'customize.customColorHint': '请直接输入所需的 Pantone 色号和颜色。',
  'customize.keepExistingColor': '保持现有颜色',
  'customize.colorPlaceholder': '例如：Pantone 185 C',

  // Shared AI progress / result
  'customize.progressLabel': '进度 (预计耗时 1 分钟–1 分 30 秒)',
  'customize.aiGeneratedImage': 'AI 生成图片',
  'customize.generatedCheck': '请查看生成的图片',
  'customize.imageLoadError': '无法加载图片',
  'customize.regenerate': '重新生成',
  'customize.viewLarge': '查看大图',
  'customize.download': '下载',
  'customize.aiGenerateAgain': '重新生成',
  'customize.generateFailed': '生成失败',
  'customize.retry': '再试一次',
  'customize.aiImageInfo': '关于 AI 生成图片',
  'customize.aiImageInfo1': '本图片是利用 AI 技术制作的参考预览图，用于帮助您更直观地了解设计及后加工的应用效果。',
  'customize.aiImageInfo2': 'AI 生成图片的形态、大小、颜色、材质、透明度、光泽、印刷位置、印刷范围及后加工效果等，可能与实际产品存在差异。',
  'customize.aiImageInfo3': '实际生产将在确认容器图纸、可印刷范围、原始设计文件、颜色标准、后加工方式及生产条件后进行，并仅在您最终确认设计稿后投产。',

  // Parts replace
  'customize.parts.selectPart': '请选择要更换的配件',
  'customize.parts.selectHint': '选中后<br />显示',
  'customize.parts.loading': '正在加载兼容配件...',
  'customize.parts.empty': '没有符合条件的产品',
  'customize.parts.aiPreview': 'AI 部件组装预览',
  'customize.parts.aiUnavailable': 'AI 处理不可用',
  'customize.parts.confirmBeforeStart': '开始前请确认',
  'customize.parts.currentlyUnavailable': '当前不可用',
  'customize.parts.aiNotice': '此任务通过 AI 进行处理。根据网络速度，可能需要 1 至 5 分钟。',
  'customize.parts.resourceNotice': '很抱歉，当前 AI 处理所需资源不足。',
  'customize.parts.start': '开始',
  'customize.parts.confirm': '确定',
  'customize.parts.resultCount': '已生成 {{count}} 个结果',
  'customize.parts.failed': '(失败)',
  'customize.parts.assemblyResult': '组装结果',

  // Finishing
  'customize.finishing.selectDesc': '请按 部位 → 后加工方式 → 颜色 的顺序选择。可以对不同部位分别指定。',
  'customize.finishingOnly.selectDesc': '请按 部位 → 后加工方式 的顺序选择。现有颜色保持不变。可以对不同部位分别指定。',
  'customize.finishing.aiGenerate': '生成 AI 后加工',
  'customize.finishing.aiPreview': 'AI 后加工预览',
  'customize.finishing.aiPreviewComplete': 'AI 预览完成',
  'customize.finishing.workingImage': '工作基准图片',
  'customize.finishing.aiResult': 'AI 生成结果',
  'customize.finishing.resultTitle': 'AI 后加工结果',

  // Color only
  'customize.color.selectHint': '请选择要更改的颜色。可从热门颜色、Premium 或直接输入中选择。',

  // Printing
  'customize.print.position': '印刷位置',
  'customize.print.positionPlaceholder': '请选择印刷位置',
  'customize.print.method': '选择印刷方式',
  'customize.print.methodPlaceholder': '请选择印刷方式',
  'customize.print.autoSet': '自动',
  'customize.print.photoTransfer': '照片转印',
  'customize.print.uploadDesign': '上传设计文件',
  'customize.print.removeFile': '移除文件',
  'customize.print.upload': '上传',
  'customize.print.allowedFormat': '支持格式：JPG、PNG、WebP',
  'customize.print.maxSize': '最大 10MB / 单边 300px 以上 / 长边 2,048px 以下',
  'customize.print.ratio': '比例 1:2.5 – 2.5:1',
  'customize.print.aiPreview': 'AI 图片预览',
  'customize.print.noDesignFile': '无设计文件',
  'customize.print.positionUnset': '未设置位置',
  'customize.print.uploadingArtwork': '正在上传图稿...',
  'customize.print.creatingJob': '正在创建印刷预览任务...',
  'customize.print.uploadFailed': '文件上传失败：{{message}}',
  'customize.print.noWorkingImage': '找不到容器工作图片，请先确认产品图片。',
  'customize.print.generateFailed': '印刷预览生成失败。',
  'customize.print.statusError': '查询状态时发生错误',
  'customize.print.unknownError': '发生未知错误。',
  'customize.print.invalidFile': '由于未知错误，无法使用该文件。',
  'customize.print.capTopTitle': 'CAP 顶面印刷提示',
  'customize.print.capTopSubtitle': '上传图片时的注意事项',
  'customize.print.capTopBody': '在 CAP 顶面印刷时，必须上传一张 CAP 顶面正对镜头的单独图片。',
  'customize.print.capTopHint': '请准备一张从正前方拍摄的 CAP 顶面（俯视图）单独图片，而非容器侧面照片。仅凭侧面图片无法准确确认顶面印刷区域。',
  'customize.print.understood': '我已知晓',
  'customize.print.uploadedFileAlt': '已上传的设计文件',
  'customize.printing.resultTitle': 'AI 印刷预览结果',

  // Printing positions
  'customize.printPosition.bodyFront': '瓶身正面',
  'customize.printPosition.middleRing': '中间环',
  'customize.printPosition.capSide': 'CAP 侧面',
  'customize.printPosition.capTop': 'CAP 顶面',
};